module.exports = __webpack_public_path__ + "img/btn02.18c51ce8.png";